module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"cgu":{"updatedTime":"Mis à jour le"}}}')
  delete Component.options._Ctor
}
